import type { AuthWrapperCbProfile } from "@jetblue/auth-wrapper";
import type { EnhancedUserData } from "../kit-auth/utils/kit-auth-map-profile";
type EnhancedUserDataProperties = {
  customerDetails: AuthWrapperCbProfile["customerDetails"];
  isCreditProfile?: boolean | undefined;
};

export const enhanceUserData = ({
  customerDetails,
  isCreditProfile = false,
}: EnhancedUserDataProperties) => {
  const enhancedData: EnhancedUserData = {
    ...customerDetails,
    firstName: customerDetails.firstName ?? "",
    fullName: "",
    initials: "",
    isCreditProfile,
    isMosaic: false,
    lastName: customerDetails.lastName ?? "",
    userImageSrc: "",
  };

  const isMosaic = isCreditProfile
    ? false
    : customerDetails.loyaltyDetails.membershipTier?.includes("MOSAIC");
  enhancedData.isMosaic = isMosaic ?? false;

  const firstName = customerDetails.firstName
    ? customerDetails.firstName.charAt(0).toUpperCase() +
      customerDetails.firstName.slice(1).toLocaleLowerCase()
    : "";
  enhancedData.firstName = firstName;

  const lastName = customerDetails.lastName
    ? customerDetails.lastName.charAt(0).toUpperCase() +
      customerDetails.lastName.slice(1).toLocaleLowerCase()
    : "";
  enhancedData.lastName = lastName;

  const firstInitial = enhancedData.firstName[0] ?? "";
  const lastInitial = enhancedData.lastName[0] ?? "";
  const initials = firstInitial + lastInitial;
  enhancedData.initials = initials;

  const fullName = enhancedData.firstName
    ? enhancedData.firstName + " " + enhancedData.lastName
    : "";
  enhancedData.fullName = fullName;

  const source =
    customerDetails.profileImageType && customerDetails.profileImage
      ? `data:${customerDetails.profileImageType};base64,${customerDetails.profileImage}`
      : "";
  enhancedData.userImageSrc = source;

  return enhancedData;
};
